const appBaseUrl = (import.meta.env.VITE_APP_URL || 'http://localhost:3000').replace(/\/+$/, '');

export const getAppUrl = (path = '/auth'): string =>
  `${appBaseUrl}${path.startsWith('/') ? path : `/${path}`}`;

export const getSignupUrl = (planId?: string, returnUrl?: string): string => {
  const params = new URLSearchParams({ mode: 'signup' });
  if (planId) params.set('plan', planId);
  if (returnUrl) params.set('returnUrl', returnUrl);
  return getAppUrl(`/auth?${params.toString()}`);
};
